<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="经销商名称" prop="opAgent">
                <el-input v-model="q.opAgent" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="测算时间" style="width: 50%;" class="nianboxs">
                <el-date-picker
                    v-model="q.startTime"
                    :clearable="true"
                    type="date"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span class="w-time-to">至</span>
                <el-date-picker
                    v-model="q.endTime"
                    :clearable="true"
                    type="date"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="测算人" prop="opUserName">
                <el-input v-model="q.opUserName" placeholder="请输入测算人工号或姓名"></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="l-screenBox">
            <div class="l-retrieval">
              <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
            </div>
          </div>
        </div>
      </div>


      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table
                  ref="ddtable"
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  :border="true"
                  max-height="430"
        >
          <el-table-column
              type="selection"
          >
          </el-table-column>
          <el-table-column
              type="index"
              label="#"
              width="40">
          </el-table-column>

          <el-table-column
              prop="opDesc"
              :show-overflow-tooltip="true"
              label="测算类型"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.opDesc}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="opAgent"
              :show-overflow-tooltip="true"
              label="经销商名称"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.opAgent}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="opUserCode"
              label="测算人工号"
              :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{scope.row.opUserCode}}
            </template>
          </el-table-column>
          <el-table-column
              prop="opUserName"
              label="测算人姓名"
              :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{scope.row.opUserName}}
            </template>
          </el-table-column>
          <el-table-column
              prop="opTime"
              :show-overflow-tooltip="true"
              label="测算时间">
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-pagination2">
            <pagination :page="q" @query="handleFilter"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'

export default {
  data() {
    return {
      //查询属性
      page: {
        opAgent: '',
        startTime: '',
        endime: '',
        opUserName:'',
        pageSize: 10,
        pageNo: 1
      },
      q: {
        opAgent: '',
        startTime: '',
        endime: '',
        opUserName:'',
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      //table列表
      tableData: [],
    }
  },
  created() {
    this.handleFilter();
  },
  methods: {
    query() {
      ss.fanli.getRebateLogPage(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
    handleFilter(){
      this.query();
    },
    qingkong(){
      this.q.opAgent = '';
      this.q.startTime = '';
      this.q.endTime = '';
      this.q.opUserName = '';
    },
  }
}
</script>
<style>
.sjwpicker .el-date-editor .el-range-separator {
  width: 8%;
  line-height: 0.35rem;
}
</style>